import { login, logout, getInfo } from "@/api/user";
import { getUserIdApi } from "@/api/auth-login";
import { getToken, setToken, removeToken, getUserName, setUserName, removeUserName } from "@/utils/auth";
// import router, { resetRouter } from "@/router";

const state = {
  token: getToken(),
  userName: getUserName()
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_USERNAME: (state, userName) => {
    state.userName = userName;
  }
};

const actions = {
  login({ commit }, userInfo) {
    const { comUscc, password } = userInfo;
    return new Promise((resolve, reject) => {
      login({ comUscc, password })
        .then((response) => {
          const { data } = response;
          if (data) {
            commit("SET_TOKEN", data.id);
            commit("SET_USERNAME", data.userName);
            setToken(data.id);
            setUserName(data.userName);
          }
          resolve(data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },

  // 统一认证登录
  authLogin({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      getUserIdApi(userInfo)
        .then((response) => {
          const { data } = response;
          if (data) {
            commit("SET_TOKEN", data.id);
            commit("SET_USERNAME", data.userName);
            setToken(data.id);
            setUserName(data.userName);
          }
          resolve(data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },

  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit("SET_TOKEN", "");
      commit("SET_USERNAME", "");
      removeToken();
      removeUserName();
      sessionStorage.removeItem("client-userInfo");
      sessionStorage.removeItem("Authorization");
      localStorage.clear();
      sessionStorage.clear();
      resolve();
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
